@if (!isEmpty(get(videoColumnsRow, 'video', ''))) {
  @for (row of get(videoColumnsRow, 'video.video', []); track row) {
    <div
        [ngStyle]="{
            'background-color': get(videoColumnsRow, 'video.exxcom_color_picker', ''),
            'background-repeat': 'no-repeat'
        }"
      >
      <section id="rows" class="container px-3 video-component">
        @if (get(row, 'video_url_and_title.title', '')) {
          <h2 class="video-title">
            {{ get(row, 'video_url_and_title.title', '') }}
          </h2>
        }
        <!-- Video Display -->
        @if (row.type === 'Video') {
          <div class="video-container">
            <video
              #videoElement
              [src]="get(row, 'video_url_and_title.href', '')"
              [title]="get(row, 'video_url_and_title.title', '')"
              controls
              muted
              playsinline
              preload="metadata"
              [attr.aria-label]="get(row, 'video_url_and_title.title', 'Video player')"
              class="video-fit"
              (error)="onVideoError($event)"
              (loadeddata)="onVideoLoaded()"
              >
              Your browser does not support the video tag.
            </video>
          </div>
        }
        <!-- GIF Display -->
        @if (row.type !== 'Video') {
          <div class="gif-container">
            <img
              [src]="get(row, 'video_url_and_title.href', '')"
              [alt]="get(row, 'video_url_and_title.title', 'Animated GIF')"
              [title]="get(row, 'video_url_and_title.title', '')"
              [attr.loading]="isBrowser ? 'lazy' : null"
              />
          </div>
        }
        @if (get(row, 'copy', '') !== '') {
          <p class="mt-3 video-copy">{{ get(row, 'copy', '') }}</p>
        }
      </section>
    </div>
  }
}
@if (get(videoColumnsRow, 'multi_column_v2.split_line', '')) {
  <hr class="m-0 mb-3" />
}
